import { groupSlugify } from "./data";


export const getGroupInfo = (pcModel, groupType) => {
  return pcModel.modelOptionGroup.find(modelOptionGroup => groupSlugify(modelOptionGroup.optionGroup.option_group_title) === groupType)
};

